var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "search-preferences--section__title",
      attrs: { id: _vm.id },
    },
    [
      _c(
        "PtCheckbox",
        {
          on: { change: _vm.syncChange },
          model: {
            value: _vm.fieldValue,
            callback: function ($$v) {
              _vm.fieldValue = $$v
            },
            expression: "fieldValue",
          },
        },
        [_vm._v(" " + _vm._s(_vm.$t(_vm.fieldConfig.label)) + " ")]
      ),
      ![_vm.SEARCH_TYPE.sequence, _vm.SEARCH_TYPE.short].includes(
        _vm.store.searchType
      )
        ? _c(
            "ElPopover",
            {
              attrs: {
                placement: "right",
                trigger: "hover",
                "visible-arrow": false,
                width: 366,
                "popper-class": "bio-search-setting__popover",
              },
            },
            [
              _c("div", { staticClass: "preferences-propver__content" }, [
                _c("p", [
                  _vm._v(
                    _vm._s(
                      _vm.$t("Search.propver.Preferences.defaultAlgorithm")
                    )
                  ),
                ]),
              ]),
              _c("PtIcon", {
                attrs: { slot: "reference", icon: "SolidInfo" },
                slot: "reference",
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }